import axios, { AxiosResponse } from "axios";
import { createBrowserHistory, Location } from "history";
import { API_URL } from "config";
import { encryptValues, getCsrfToken } from "helpers/commonHelpers";

const myHistory = createBrowserHistory({ window });

const client = axios.create({
  baseURL: API_URL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Ensure cookies are sent with requests
});

client.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

client.interceptors.request.use(
  (config) => {
    const csrfToken = getCsrfToken();

    if (csrfToken) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response: AxiosResponse) => response.data,
  (error) => {
    if (!error.response) {
      throw new Error("Error Connection");
    }
    if (error.response.status === 401) {
      window.localStorage.clear();
      myHistory.replace(`/`);
      window.location.reload();
    }

    return Promise.reject(error.response.data);
  }
);

export default client;

export const setAuthToken = (token: string | null) => {
  client.defaults.headers.common.Authorization = "";
  // delete client.defaults.headers.common.Authorization;
  if (token) {
    localStorage.setItem("serviceToken", token);
    client.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem("serviceToken");
    delete client.defaults.headers.common.Authorization;
  }
};

export const setAuthUser = (user: Object | null) => {
  if (user) {
    const encryptedUser = encryptValues(JSON.stringify(user)); // Encrypt the user object
    localStorage.setItem("userData", JSON.stringify(encryptedUser)); // Store the encrypted user object
  } else {
    localStorage.removeItem("userData");
  }
};

export const getHistoryLocation = (): Location => {
  return myHistory.location;
};
